import {ICondition, IImportFormat, ISyncField} from "../../../../index";
import {ObjectTypeId} from "../../../../constants";
import {global} from "../../../../appContext";
import {nsSyncFields} from "../../../../req/nsSyncFields";
import {nsRuleset} from "../../nsRuleset";
import {ErrorManager} from "../../../../error/ErrorManager";
import {MutableRuleset as MutableRuleset} from '../mutableRuleset'
import PromiseRequest from "../../../../req/PromiseRequest";
import {nsDataSource} from "../../../../util/nsDataSource";
import getCondition = nsRuleset.getCondition;

interface IParams {
    errManagerInfo: ErrorManager
    errManagerRules: ErrorManager
    ruleset: MutableRuleset
}

export class AvailableData {
    private ObjectTypeId!: ObjectTypeId;

    private reqGetConditions = global.getPromiseRequest("getconditions");

    public conditions!: ICondition[];
    public syncfields: { [value in ObjectTypeId]?: ISyncField[] } = {}
    public readonly errManagerInfo: ErrorManager
    public readonly errManagerRules: ErrorManager
    public readonly ruleset: MutableRuleset
    public importformats!: IImportFormat[];
    public importformatTypes: nsDataSource.IImportFormatType[] = []

    constructor(params: IParams) {
        this.errManagerInfo = params.errManagerInfo
        this.errManagerRules = params.errManagerRules
        this.ruleset = params.ruleset
    }

    public init(): Promise<void> {
        return Promise.resolve()
            .then(() => new PromiseRequest('getimportformats')
                .request()
                .then((data: IImportFormat[]) => this.importformats = data)
                .then(() => {
                    const org = global.login.selectedOrganization()
                    if (!org) {
                        return
                    }
                    if (nsDataSource.hasImportFormatType(org.importformats, 'hr')) {
                        this.importformatTypes.push(nsDataSource.ImportFormatTypes['hr'])
                    }
                    if (nsDataSource.hasImportFormatType(org.importformats, 'edu')) {
                        this.importformatTypes.push(nsDataSource.ImportFormatTypes['edu'])
                    }
                })
            )
            .then(() => this.reqGetConditions
                .request()
                .then((data: ICondition[]) => {
                    this.conditions = data
                })
            )
            .then(() => nsSyncFields
                .getSyncFields(ObjectTypeId.Event)
                .request
                .then((data: ISyncField[]) => {
                    this.syncfields[ObjectTypeId.Event] = data
                })
            );
    }

    getArgumentType(argumentoperator: string): ICondition['type'] | undefined {
        const condition = getCondition(argumentoperator, this.conditions);
        return condition?.type;
    }

    dispose() {
        this.reqGetConditions.abort();
    }
}
